import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reduxForm, Field, stopSubmit, startSubmit} from 'redux-form'


import BackOfficeNavigatorScreen from '../screens/BackOfficeNavigatorScreen'
import {Route, Switch, Redirect} from 'react-router-dom'
import PassListContainer from './PassListContainer'
import BackOfficeReceiptScreen from '../screens/BackOfficeReceiptScreen'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

const mapStateToProps = (state) => {
  return {
    state: state.users
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

class BackOfficeReceiptsTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      receipts: [],
      filters: {},
      loading: false
    }

    this.fetchReceipts = this.fetchReceipts.bind(this)
    this.onRowClick = this.onRowClick.bind(this)
  }

  componentDidMount () {
    this.setState({loading: true})
    this.fetchReceipts()
  }

  fetchReceipts (filterObj, limit, offset) {
    this.setState({loading: true})
    let string = ''
    for (let key in filterObj) {
      string = string + key + '=' + filterObj[key] + '&'
    }

    SostaOnlineApiService.fetchReceipts(string, limit || 100, offset || 0).then((data) => {
      this.setState({
        receipts: data.data,
        pagination: data.pagination,
        loading: false
      })
    })
  }

  onRowClick (rowIdx, row) {
    if (rowIdx <= -1 || !row.Order.userId) {
      return
    }

    let scrollTo = ''
    if (row.Order.ParkTicketOrders.length > 0) {
      scrollTo = '?scrollTo=park-ticket-' + row.Order.ParkTicketOrders[0].parkTicketId
    } else if (row.Order.MarkOrders.length > 0) {
      scrollTo = '?scrollTo=mark-' + row.Order.MarkOrders[0].markId
    }
    this.props.history.push('/backoffice/users/' + row.Order.userId + scrollTo)
  }

  render () {
    return (
      <BackOfficeReceiptScreen
        loading={this.state.loading}
        fetchReceipts={this.fetchReceipts}
        receipts={this.state.receipts}
        rows={this.state.receipts}
        pagination={this.state.pagination}
        onRowClick={this.onRowClick} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeReceiptsTableContainer);


// WEBPACK FOOTER //
// ./src/containers/BackOfficeReceiptsTableContainer.js